import { render, staticRenderFns } from "./GeradorConteudo.vue?vue&type=template&id=16f90319"
import script from "./GeradorConteudo.vue?vue&type=script&lang=js"
export * from "./GeradorConteudo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports